import React from 'react';
import { FormGroup, Button } from '@mui/material';
import { useStyles } from '../Styles';
import PropTypes from 'prop-types';

export default function LoginButton(props) {
  const classes = useStyles();

  return (

    <FormGroup>

      <Button
        className={classes.buttonRegister}
        variant="contained"
        size="large"
        type="submit"
        disabled={props.disabled}
      >
        {' '}
        Entrar
        {' '}
      </Button>

    </FormGroup>

  );
}

LoginButton.defaultProps = {
  props: { disabled: false },
};

LoginButton.propTypes = {
  /** Recebe as propiedades para o botão de login */
  props: PropTypes.object,
};
